import privacyContent from '../../Constants/privacy.json'
import termsContent from '../../Constants/terms.json'
import eventRulesContent from '../../Constants/rules.json'
import MarkdownPage from '../../Components/Common/MarkdownPage'

interface MarkdownPageMapperProps {
    contentType: 'privacy' | 'imprint' | 'terms' | 'event-rules'
}

const contentMap = {
    privacy: privacyContent.privacy,
    terms: termsContent.terms,
    imprint: privacyContent.imprint,
    'event-rules': eventRulesContent['event-rules'],
}

const titleKeyMap = {
    privacy: 'pages.privacy',
    imprint: 'pages.imprint',
    terms: 'pages.terms',
    'event-rules': 'pages.eventRules',
}

const MarkdownPageMapper = ({ contentType }: MarkdownPageMapperProps) => {
    return (
        <MarkdownPage
            text={contentMap[contentType]}
            titleKey={titleKeyMap[contentType]}
        />
    )
}

export default MarkdownPageMapper
